import Navigation from "@/components/Navigation";
import { Helmet } from "react-helmet-async";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Menu from "@/components/Menu";
import Booking from "@/components/Booking";
import VideoGallery from "@/components/VideoGallery";
import Gallery from "@/components/Gallery";
import GoogleReviews from "@/components/GoogleReviews";
import Contact from "@/components/Contact";
import SocialMedia from "@/components/SocialMedia";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollProgress from "@/components/ScrollProgress";
import { useParallax } from "@/hooks/useParallax";

const Index = () => {
  useParallax();

  return (
    <div className="min-h-screen relative">
      <Helmet>
        <title>Currylicious Yum Yum – Indisk, Thai & Sushi i Skanör</title>
        <meta name="description" content="Premium fusionsrestaurang i Skanör. Boka bord, beställ takeaway eller se vår à la carte-meny med indisk, thailändsk och japansk mat." />
        <link rel="canonical" href="https://www.currylicious.se/" />
        <meta property="og:title" content="Currylicious Yum Yum – Indisk, Thai & Sushi i Skanör" />
        <meta property="og:description" content="Premium fusionsrestaurang i Skanör. Boka bord, beställ takeaway eller upptäck vår à la carte-meny." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.currylicious.se/" />
        <meta property="og:image" content="https://www.currylicious.se/og-image.jpg" />
      </Helmet>
      <ScrollProgress />
      <Navigation />
      <Hero />
      <About />
      <Menu />
      <VideoGallery />
      <Gallery />
      <GoogleReviews />
      <Contact />
      <Booking />
      <SocialMedia />
      <Footer />
      <ScrollToTop />

    </div>
  );
};

export default Index;
